import { render, staticRenderFns } from "./EspecieEmail.vue?vue&type=template&id=2a27249d&"
import script from "./EspecieEmail.vue?vue&type=script&lang=js&"
export * from "./EspecieEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports